import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { ButtonHTMLAttributes } from 'react';

type EngagementIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

export function EngagementIconButton({
  label = 'Engajamento',
  className = '',
  ...props
}: EngagementIconButtonProps) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-primary-50 hover:text-primary-600 ${className}`}
      {...props}
    >
      <ChatBubbleLeftRightIcon className="h-5 w-5" />
    </button>
  );
}
